import React from 'react'
import './CreateLinkPage.css'
import LinkView from 'components/LinkView/LinkView'
import { LINK_VIEW_MODES } from 'constants/general.constants'

export default function CreateLinkPage() {
    return (
        <LinkView mode={LINK_VIEW_MODES.CREATE} />
    )
}